/**
 * First sleeve added with the Hybrid Cup configurator: sent as cart line `description`.
 * Must match `ProtectedProducts.IncludedWithHybridCupSleeveDescription` in vi-core-api.
 */
export const HYBRID_CUP_INCLUDED_SLEEVE_DESCRIPTION = 'Included with Hybrid Cup'
